import {EventsEmitterComposer} from './EventsEmitter'
import EventsEmitter from './EventsEmitter'

EventsEmitter.Composer = EventsEmitterComposer

export default EventsEmitter
